import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  getInstanceOnly,
  AccountUserProvider,
  GetAccountUsersProviderOptions,
} from '../lib/client';

export interface InitialState {
  saving: boolean;
  error: string;
  success: boolean;
  users: Array<AccountUserProvider>;
}

export const getAccountUsersProvider = createAsyncThunk(
  'accountUsersProvider/getAccountUsersProvider',
  async (opts: GetAccountUsersProviderOptions) => {
    const instance = getInstanceOnly();
    const users = await instance.getAccountUsersProvider(opts);
    return users;
  }
);

const initialState: InitialState = {
  saving: false,
  error: '',
  success: false,
  users: [],
};

const accountUsersProviderSlice = createSlice({
  name: 'accountUsersProviderSlice',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    // getUserConfig
    builder.addCase(getAccountUsersProvider.pending, (state) => {
      state.saving = true;
      state.success = false;
      state.error = '';
    });
    builder.addCase(
      getAccountUsersProvider.fulfilled,
      (state, action: PayloadAction<Array<AccountUserProvider>>) => {
        state.saving = false;
        state.success = true;
        state.error = '';
        state.users = action.payload;
      }
    );
    builder.addCase(getAccountUsersProvider.rejected, (state, action) => {
      console.error(action.error);
      state.saving = false;
      state.success = false;
      state.error = 'Unable to get users of the provider';
    });
  },
});

export const { reset } = accountUsersProviderSlice.actions;
export default accountUsersProviderSlice;
